import React from 'react';

const UnauthenticatedRouteLanguageContext = React.createContext({});
UnauthenticatedRouteLanguageContext.displayName = 'UnauthenticatedRouteLanguageContext';
export default UnauthenticatedRouteLanguageContext;
